module.exports = __webpack_public_path__ + "static/media/Data_download_description.5d4bf06d.pdf";